module.exports = __webpack_public_path__ + "media/audio12.c55ef349.mp3";